import { gql } from '@apollo/client';
import MoneyFields from '../../fragments/money/money-fields';

const ShoppingFields = gql`
  fragment ShoppingFields on ShoppingCartSummaryType {
    invoiceCount
    clientCount
    totalAmount {
      ...MoneyFields
    }
    priceDifference {
      ...MoneyFields
    }
    commission {
      ...MoneyFields
    }
    totalCosts {
      ...MoneyFields
    }
    retainedAmount {
      ...MoneyFields
    }
    financedAmount {
      ...MoneyFields
    }
    orderingDebt {
      ...MoneyFields
    }
    negativeSurplus {
      ...MoneyFields
    }
    rate
    retentionRate
    hasPurchaseOrdersNearToDebt
    depositAmount {
      ...MoneyFields
    }
  }
  ${MoneyFields}
`;

export default ShoppingFields;
